export enum EDmsMediaPriority {
	primary = 0,
	alternative
}
